import {SlideShow} from "../components/SlideShow";
import {FeaturedCard} from "../components/FeaturedCard";
import {Card} from "../components/Card";
import {FaChevronCircleRight} from "react-icons/fa";
import {Link} from "react-router-dom";
import useSWR from "swr";
import {NavBackground} from "../components/NavBackground";
import {apiUrl} from "../index";

const fetcher = async (path) => {
    return fetch(apiUrl + path).then((res) => res.json());
}

export function Home() {

    const {data, error, isLoading} = useSWR("/houses/list", fetcher);

    if (isLoading) {
        return (
            <>
                <NavBackground backgroundColor={"var(--color-primary)"} />
                <div className="loadingStatus">
                    <div className="spinner"></div>
                    <h2>Angebote werden geladen...</h2>
                </div>
            </>
        )
    }

    if (error) {
        return (
            <>
                <NavBackground backgroundColor={"var(--color-primary)"}/>
                <div className="loadingStatus">
                    <h2>Fehler beim Laden der Angebote</h2>
                </div>
            </>
        );
    }

    // Extract first 5 images for the slideshow
    const images = data?.slice(0, 5).map(item => `${apiUrl}/images/${item.thumbnail}`) || [];

    return (
        <main className="homePage">
            <NavBackground backgroundColor={"var(--color-primary)"} position={"absolute"}/>

            {images.length > 0 && <SlideShow images={images} />}

            <section className="offerContainer">
                {data?.length > 0 ? (
                    <>
                        <div className="offersTitle">
                            <span className="offersTitleDesktop">Wohnträume in besten Lagen: Ihre exklusive Immobilienauswahl auf Sylt</span>
                            <span className="offersTitleMobile">Ihre exklusive Immobilienauswahl auf Sylt</span>
                        </div>

                        <div className="featuredOffers">
                            {data.filter((house) => house.featured).map(house => (
                                <FeaturedCard key={house._id} properties={house} />
                            ))}
                        </div>

                        <div className="normalOffers">
                            {data.filter((house) => !house.featured).map(house => (
                                <Card key={house._id} properties={house} />
                            ))}
                        </div>
                    </>
                ) : (
                    <div className="emptyOffers">Aktuell sind keine Angebote vorhanden</div>
                )}
            </section>

            <section className="aboutSection">
                <div className="aboutContentWrapper">
                    <div className="aboutTitle">
                        Über uns
                    </div>
                    <div className="aboutText">
                        <strong>INSOLITO</strong> steht für Qualität: Qualität, die man sieht und fühlt. In jedem Raum und jeder Ecke unserer
                        Appartements. Neben den renommierten Marken finden Sie in unseren Appartements viele Dinge, die es
                        NUR bei INSOLITO gibt. Denn viele Produkte lässt INSOLITO exklusiv in traditionellen Manufakturen
                        fertigen.
                    </div>

                    <div className="aboutLearnMoreContainer">
                        <Link to="/about" className="aboutLearnMoreBtn">
                            <span>Mehr erfahren</span>
                            <FaChevronCircleRight className="aboutLearnMoreIcon" />
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    )
}
